import Hero from "@/components/Hero";
import BrandStamp from "@/components/BrandStamp";
import { ServicesGrid, TrustSection } from "@/components/ServicesAndTrust";
import Testimonials from "@/components/Testimonials";
import BranchesPreview from "@/components/Branches";
import RateEnquiry from "@/components/RateEnquiry";
import { IMAGES } from "@/lib/brand";

export default function Home() {
  return (
    <div>
      <Hero />

      <BrandStamp
        variant="gold"
        tagline={
          <>
            Instant Cash · Bank Transfer in 30 Minutes · Govt. Approved Valuers
          </>
        }
      />

      <ServicesGrid />

      <BrandStamp
        variant="light"
        tagline={<>Trusted by families across Gurgaon &amp; Delhi NCR</>}
      />

      <TrustSection />

      <BrandStamp
        variant="dark"
        tagline={<>Sona Do Paisa Lo · No Manipulation · Only Best Rate</>}
      />

      {/* Editorial split section */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#641C24] font-bold">
              Instant Cash · Real Trust
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-4 leading-[1.05]">
              Bring in a bangle, ring, biscuit or scrap —
              <span className="italic text-[#641C24]"> walk out with cash.</span>
            </h2>
            <p className="text-[#4A3B3C] text-base leading-relaxed mt-6">
              From a single earring to family heirlooms, every gram is
              evaluated openly. Our XRF karat machines and calibrated scales
              are placed on your side of the counter so you see the reading in
              real time.
            </p>
            <ul className="mt-6 space-y-3 text-sm text-[#2D181A]">
              <li className="flex items-start gap-3">
                <span className="mt-1 w-1.5 h-1.5 bg-[#D4AF37] shrink-0" />
                Free evaluation — no commitment to sell
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-1 w-1.5 h-1.5 bg-[#D4AF37] shrink-0" />
                Cash upto ₹2 lakh, bank transfer for larger deals
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-1 w-1.5 h-1.5 bg-[#D4AF37] shrink-0" />
                PAN + ID required as per govt. regulations
              </li>
            </ul>
          </div>
          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="grid grid-cols-2 gap-4">
              <img
                src={IMAGES.biscuits}
                alt="Gold biscuits and bars"
                loading="lazy"
                className="w-full h-56 md:h-72 object-cover"
              />
              <img
                src={IMAGES.ornament1}
                alt="Traditional Indian gold necklace"
                loading="lazy"
                className="w-full h-56 md:h-72 object-cover"
              />
              <img
                src={IMAGES.cashHands}
                alt="Cash payout in hand"
                loading="lazy"
                className="col-span-2 w-full h-48 md:h-60 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <BrandStamp
        variant="gold"
        tagline={<>Two Branches in Gurgaon · Home Visits Across North India</>}
      />

      <RateEnquiry />

      <Testimonials />

      <BrandStamp
        variant="dark"
        tagline={<>The most trusted address for cash-for-gold in North India</>}
      />

      <BranchesPreview />
    </div>
  );
}
